import Save from "@mui/icons-material/Save";
import { IconButton } from "@mui/material";
import { useCallback } from "react";
import { useLocation } from "react-router";
import { useUserPreferences } from "../../hooks/useUserPreferences";
import { RequestToSend } from "../../models/RequestToSend";
import { addRequestToSend } from "../../redux/features/appStateSlice";
import { useUpdateUserPreferencesMutation } from "../../redux/features/cache";
import { useAppDispatch, useAppSelector } from "../../redux/store";

export const SavePreferencesButton = () => {
  const user = useAppSelector((state) => state.appState.user);

  const [updateUserPreferences] = useUpdateUserPreferencesMutation();

  const dispatch = useAppDispatch();
  const userPreferences = useUserPreferences();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSaveUserPreferences = useCallback(() => {
    let newUserPreferences = userPreferences.getUserPreferences();

    dispatch(
      addRequestToSend(
        new RequestToSend(
          `Sauvegarde des préférences`,
          updateUserPreferences,
          () => { },
          {},
          {
            user: user,
            query: newUserPreferences,
          },
          []
        )
      )
    );
  }, [dispatch, updateUserPreferences, user, userPreferences]);

  return (
    <IconButton onClick={() => handleSaveUserPreferences()} aria-label="Save">
      <Save />
    </IconButton>);
}
